var cov_dsyfo6gjz = function () {
  var path = "/Users/spana/SHEIN/shineout/src/Checkbox/Checkbox.ts",
      hash = "82a6549c593b33f3a9b525402ff86c151d33b46f",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/Checkbox/Checkbox.ts",
    statementMap: {
      "0": {
        start: {
          line: 3,
          column: 17
        },
        end: {
          line: 3,
          column: 38
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import checkItem from './CheckItem';
var Checkbox = (cov_dsyfo6gjz.s[0]++, checkItem('checkbox'));
export default Checkbox;